(function(){
  'use strict';
  document.querySelectorAll('[data-garment-size-guide]').forEach(function(dialog){
    if(dialog.dataset.initialized)return;dialog.dataset.initialized='true';
    var previousFocus=null;
    document.querySelectorAll('[data-size-open]').forEach(function(trigger){
      if(trigger.dataset.sizeOpen!==dialog.id)return;
      trigger.addEventListener('click',function(){previousFocus=trigger;dialog.showModal();dialog.querySelector('[data-size-close]').focus();});
    });
    dialog.querySelector('[data-size-close]').addEventListener('click',function(){dialog.close();});
    dialog.addEventListener('close',function(){if(previousFocus&&previousFocus.isConnected)previousFocus.focus();});
    dialog.querySelectorAll('[data-size-unit]').forEach(function(button){
      button.addEventListener('click',function(){
        var unit=button.dataset.sizeUnit,format=new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:1});
        dialog.querySelectorAll('[data-size-cm]').forEach(function(cell){var cm=Number(cell.dataset.sizeCm);cell.textContent=format.format(unit==='in'?cm/2.54:cm);});
        dialog.querySelectorAll('[data-size-unit]').forEach(function(item){item.setAttribute('aria-pressed',String(item===button));});
        dialog.querySelector('[data-size-unit-label]').textContent=unit;
      });
    });
  });
})();
